import generateTypes from '../utils/generateTypes';

export const GET_COLLECTIONS = generateTypes('GET_COLLECTIONS');
export const RESET_COLLECTIONS = generateTypes('RESET_COLLECTIONS');
